<template>
  <div class="search_box">
    <!-- 搜索条件 -->
    <div class="earch_head">
      <div v-for="(item,index) in list" :key="index" class="earch_head_li">
        <!-- <span class="span_label">{{item.name}}:</span> -->
        <span class="search_font">{{ item.placeholder }} </span>

        <a-select
          v-if="item.type == 'select_search'"
          class="select_width"
          :placeholder="'请选择'+item.label"
          v-model="item.value"
          :options="item.options"
          :allowClear="true"
          show-search
          :value="value"
          :default-active-first-option="false"
          :filter-option="false"
          :not-found-content="null"
          @search="handleSearch"
          @change="handleChange"
        ></a-select>

        <a-select
          v-if="item.type == 'select'"
          class="select_width"
          :allowClear="true"
          :placeholder="item.label"
          v-model="item.value"
          :options="item.options"
        ></a-select>

        <a-input
          v-if="item.type == 'input' "
          :allowClear="true"
          class="select_width"
          v-model="item.value"
          :placeholder="item.label"
        />

        <a-range-picker
          v-if="item.type == 'range'"
          class="range"
          :placeholder="item.placeholder"
          v-model="item.value"
        />

        <a-date-picker
          v-if="item.type == 'date'"
          :placeholder="item.label"
          class="select_width"
          v-model="item.value"
        />

        <a-input-group compact v-if="item.type == 'inputGroup'">
          <a-input
            v-model:value="item.firstvalue"
            style="width: 130px; text-align: center"
            :placeholder="item.firstlabel"
          />
          <a-input
            style="width: 30px; border-left: 0; pointer-events: none; background-color: #fff"
            placeholder="-"
            disabled
          />
          <a-input
            v-model:value="item.endvalue"
            style="width: 130px; text-align: center; border-left: 0"
            :placeholder="item.endlabel"
          />
        </a-input-group>
      </div>
      <div class="all_head end">
        <a-button type="primary" @click="handle_seach">查询</a-button>
        <a-button type="primary" ghost @click="handle_add">添加</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: {
    filterData: {
      type: Array,
      default: () => {
        return [];
      }
    },
  },
  data() {
    return {
      list: [],
      value: ""
    };
  },
  mounted() {
    this.list = this.filterData;
  },
  methods: {
    // 查询
    handle_seach() {
      let obj = {};
      this.list.map(item => {
        if (item.type != "range" &&  item.type != "inputGroup") {
          obj[item.name] = item.value!=undefined?item.value : null;
        } else if(item.type === "range"){
          if (item.value && item.value[0]) {
            obj[item.name[0]] = moment(item.value[0]).format("YYYY-MM-DD");
            obj[item.name[1]] = moment(item.value[1]).format("YYYY-MM-DD");
          } else {
            obj[item.name[0]] = null;
            obj[item.name[1]] = null;
          }
        } else if(item.type === "inputGroup"){
          if (item.firstvalue || item.endvalue) {
            obj[item.name[0]] = item.firstvalue;
            obj[item.name[1]] = item.endvalue;
          } else {
            obj[item.name[0]] = null;
            obj[item.name[1]] = null;
          }
        }
      });
      console.log(obj,"11111111")
      this.$emit("handle_seach", obj);
    },
    //批量冻结
    handle_add() {
      this.$emit("handle_add");
    },
    handleSearch(value) {
      this.value = value;
    },
    handleChange(value) {
      this.list[4].value = value;
    },  
  }
};
</script>

<style scoped>
.earch_head {
  display: flex;
  flex-flow: wrap;
}

.earch_head_li {
  margin-right: 10px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;

  .search_font{
    font-size: 14px;
  }
}
.select_width {
  width: 168px;
}
.earch_head_li .range {
  width: 300px !important;
}
.span_label {
  width: 120px;
  font-size: 14px;
  margin-right: 5px;
  text-align: right;
}
.end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.end > * {
  margin-left: 10px;
  margin-bottom: 15px;
}
</style>